import * as turf from "@turf/turf";

import { SiteLayer } from "./SiteLayer";
import { SiteMapData } from "../../../../typings";

export const buildSiteLayer = (siteMapData?: SiteMapData) => {
  if (!siteMapData) {
    return null;
  }

  const siteGeometry = siteMapData.geometry;

  if (!siteGeometry) {
    return null;
  }

  const features = [turf.feature(siteGeometry)];

  return new SiteLayer({
    features,
    hexColor: siteMapData._stage.color,
  });
};
